import { z } from "zod";

import { richTextSchema } from "./rich-text";

export const historyInformationSchema = z
  .object({
    type: z.literal("historyInformation"),
    icon: z.string().nullable(),
    year: z.string(),
    title: z.string(),
    description: richTextSchema,
  })
  .nullable();
